import { me as meApi } from '@/api/endpoints'

const ACCEPTED_STMT_KEY = 'dcfund_accepted_statements'

function getAcceptedStatements() {
  try {
    return JSON.parse(sessionStorage.getItem(ACCEPTED_STMT_KEY)) || []
  } catch {
    return []
  }
}

function addAcceptedStatement(id) {
  const ids = getAcceptedStatements()
  if (!ids.includes(id)) {
    ids.push(id)
    sessionStorage.setItem(ACCEPTED_STMT_KEY, JSON.stringify(ids))
  }
}

function clearAcceptedStatements() {
  sessionStorage.removeItem(ACCEPTED_STMT_KEY)
}

export default {
  namespaced: true,
  state: {
    meData: null,
    clientTypeCode: null,
    passwordExpired: false
  },
  getters: {
    isIndividual: state => state.clientTypeCode && /^INDIVIDUAL/.test(state.clientTypeCode),
    isInstitutional: state => state.clientTypeCode && !/^INDIVIDUAL/.test(state.clientTypeCode)
  },
  mutations: {
    SET_ME(state, data) {
      const accepted = getAcceptedStatements()
      state.meData = {
        ...data,
        // Filter out already-accepted statement IDs so the router guard won't re-show them
        firstTimeStatementId: accepted.includes(data.firstTimeStatementId) ? null : data.firstTimeStatementId,
        yearlyStatementId: accepted.includes(data.yearlyStatementId) ? null : data.yearlyStatementId
      }
      state.clientTypeCode = state.meData.clientTypeCode
      state.passwordExpired = state.meData.passwordExpired
    },
    CLEAR_ME(state) {
      state.meData = null
      state.clientTypeCode = null
      state.passwordExpired = false
      clearAcceptedStatements()
    },
    MARK_STATEMENT_ACCEPTED(state, id) {
      addAcceptedStatement(id)
      if (state.meData) {
        if (state.meData.firstTimeStatementId === id) state.meData.firstTimeStatementId = null
        if (state.meData.yearlyStatementId === id) state.meData.yearlyStatementId = null
      }
    },
    CLEAR_PASSWORD_EXPIRED(state) {
      state.passwordExpired = false
      if (state.meData) {
        state.meData.passwordExpired = false
      }
    }
  },
  actions: {
    async fetchMe({ commit, state }) {
      if (state.meData) return state.meData
      const data = await meApi()
      commit('SET_ME', data)
      return state.meData
    }
  }
}
